// extracted by mini-css-extract-plugin
var _1 = "ChartLegendText-moduletext__MExWc Text-moduletext__Z2j5F";
export { _1 as "text" }
